import { CentreVaccinationState, Lieux } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getAllLieux } from '@/services/api/lieux/api';

import _ from 'lodash';

const namespaced: boolean = true;

export const state: CentreVaccinationState = {
	lieux: [],
	errorCode: ''
};

export const mutations: MutationTree<CentreVaccinationState> = {
	mutateLieux(state: CentreVaccinationState, listLieux: Lieux[]): void {
		state.lieux = listLieux;

	},
	mutateError(state: CentreVaccinationState, error: string): void {
		state.errorCode = error;
	}
};

export const actions: ActionTree<CentreVaccinationState, RootState> = {
	loadListLieux(state): Promise<void> {
		return new Promise((resolve, reject) => {
			if (_.isEmpty(state.state.lieux)) {
				getAllLieux()
					.then((response: any) => {
						state.commit('mutateLieux', _.get(response, 'data.value.lieux'));
						state.commit('mutateError', _.get(response, 'data.value.errorCode'));
						state.state.lieux.forEach((lieu) => {
							lieu.libelleAffichage = lieu.libelle + ' - ' + lieu.codePostal + ' - ' + lieu.libelleCommune;
						});
						resolve();
					})
					.catch(() => {
						reject();
					});
			} else {
				resolve();
			}
		});
	}
};

export const getters: GetterTree<CentreVaccinationState, RootState> = {
	getListLieux(state) {
		return state.lieux;
	}
};

export const centreVaccination: Module<CentreVaccinationState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
